import { advancedFilterScripts } from "./bg-advanced-filters.ts";
import { initCounterAnimation } from "./animated-counter.ts";

window.addEventListener('load', () => {
    advancedFilterScripts()
    initCounterAnimation()
})